import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CustomerListTable from "./CustomerTable";

const CustomerLogs = () => {
    return (
        <Box>
            <Typography variant="h5" component="h5" mb={1} fontWeight={600}>
                Customers
            </Typography>
            <CustomerHeader />
        </Box>
    );
}

const CustomerHeader = () => {

    return (
        <>

            <Box sx={{ width: "100%", padding: "24px 12px", background: "white", borderRadius: "5px" }} my={2}>


                <CustomerListTable />

            </Box>
        </>
    );
}

export default CustomerLogs;